exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vue-treeselect__control{font-size:.875rem!important}.bills-table{height:75vh;font-size:9pt}.bills-table .bills-thumbs{width:80px;max-height:80px}.bills-table .bills-table-style-actions .actions-icons{text-align:center}.bills-table .bills-table-style-datetime{width:110px}.bills-table .bills-table-style-datetime .actions-icons{text-align:center}.bills-table .tag-badges{margin:2px;padding:5px}", ""]);

// exports
